// The active industry, for every page. App resolves the slug from the
// subdomain once and provides it here, so a page never re-reads location and
// every API call it makes is scoped to the same tenant.
import { createContext, useContext, type ReactNode } from "react";
import type { IndustrySlug, IndustrySummary } from "@dashboard-intelligent/api/src/modules/industry/types";

export interface IndustryContextValue {
  slug: IndustrySlug;
  /** Null until /api/industries answers, or when it fails. */
  summary: IndustrySummary | null;
  /** Every industry, for the switcher. Empty until loaded. */
  all: IndustrySummary[];
}

const IndustryContext = createContext<IndustryContextValue | null>(null);

export function IndustryProvider({ value, children }: { value: IndustryContextValue; children: ReactNode }) {
  return <IndustryContext.Provider value={value}>{children}</IndustryContext.Provider>;
}

export function useIndustry(): IndustryContextValue {
  const value = useContext(IndustryContext);
  if (!value) throw new Error("useIndustry must be used inside <IndustryProvider>");
  return value;
}
